(ns frontend.actions.issue-reporting
  (:require [frontend.conn :as conn]
            [promesa.core :as p]))

(defn *->localization-missing [kw on-success! on-error!]
  (-> (conn/sendp! :issue-reporting/localization-missing
                   {:localization-key kw})
      (p/then on-success!)
      (p/catch on-error!)))

